import { motion } from 'motion/react';
import { HOVER_SPRING } from 'src/lib/motion.ts';

const VARIANT_CLASSES = {
  primary:
    'bg-zeb-primary text-white hover:bg-zeb-primary-hover active:bg-zeb-primary-active focus:ring-zeb-primary/40 focus:ring-offset-2',
  contrast:
    'bg-zeb-tertiary text-white hover:bg-zeb-secondary active:bg-zeb-secondary focus:ring-white/50'
} as const;

const SIZE_CLASSES = {
  md: 'px-7 py-3.5 text-base',
  lg: 'px-9 py-4.5 text-body-lg'
} as const;

export function PrimaryButton({
  children,
  onClick,
  variant = 'primary',
  size = 'md'
}: {
  children: React.ReactNode;
  onClick: () => void;
  variant?: keyof typeof VARIANT_CLASSES;
  size?: keyof typeof SIZE_CLASSES;
}) {
  return (
    <motion.button
      onClick={onClick}
      whileHover={{ y: -1 }}
      whileTap={{ scale: 0.98 }}
      transition={HOVER_SPRING}
      className={`inline-flex items-center justify-center rounded-sm shadow-zeb-sm transition-[box-shadow,background-color] hover:shadow-zeb-md focus:outline-none focus:ring-2 ${SIZE_CLASSES[size]} ${VARIANT_CLASSES[variant]}`}
      style={{ fontWeight: 600 }}>
      {children}
    </motion.button>
  );
}
